module.exports = __webpack_public_path__ + "img/GOT (AST).2(mid).9ca69ca4.jpg";